<div class="app-toast" [class]="'app-toast app-toast--' + position()" aria-live="polite" aria-atomic="false">
  @for (message of messageService.messages(); track message.id) {
    <div
      class="app-toast__message"
      [class]="'app-toast__message app-toast__message--' + (message.severity || 'info')"
      role="alert"
    >
      <span class="app-toast__icon" aria-hidden="true">
        @if (message.severity === 'error') {
          <i class="app-icon app-icon-exclamation-triangle" aria-hidden="true"></i>
        } @else {
          <i class="app-icon app-icon-check" aria-hidden="true"></i>
        }
      </span>
      <span class="app-toast__text">{{ message.message }}</span>
      @if (message.closable !== false) {
        <button type="button" class="app-toast__close" aria-label="Dismiss notification" (click)="dismiss(message)">
          <i class="app-icon app-icon-times" aria-hidden="true"></i>
        </button>
      }
    </div>
  }
</div>
